import React, { lazy } from "react"
import { Common } from "lib/types"
import { ReactComponent as CampaignIcon } from "images/icons/badge-percent.svg"
import { PermissionGroups } from "../constants"

const Campaigns = lazy(() => import("views/Campaigns/Campaigns").then(m => ({ default: m.Campaigns })))
const ShowCampaigns = lazy(() => import("views/Campaigns/ShowCampaigns").then(m => ({ default: m.ShowCampaigns })))
const CreateCampaign = lazy(() => import("views/Campaigns/CreateCampaign").then(m => ({ default: m.CreateCampaign })))
const UpdateCampaignGroup = lazy(() => import("views/Campaigns/UpdateCampaignGroup").then(m => ({ default: m.UpdateCampaignGroup })))
const UpdateCampaign = lazy(() => import("views/Campaigns/UpdateCampaign").then(m => ({ default: m.UpdateCampaign })))
const DuplicateCampaign = lazy(() => import("views/Campaigns/DuplicateCampaign").then(m => ({ default: m.DuplicateCampaign })))

export const campaignRoutes: Common.Views = [
  {
    element: <Campaigns />,
    path: "/campaigns",
    title: "Campaigns",
    icon: CampaignIcon,
    sortOrder: 3,
    requiredGroups: PermissionGroups.campaigns.read,
    configKey: "campaignEnabled",
    children: [
      {
        element: <ShowCampaigns />,
        path: "/campaigns/",
        title: "Show campaigns",
        parentPath: "/campaigns",
        section: "Campaigns"
      },
      {
        element: <CreateCampaign />,
        path: "/campaigns/create-campaign",
        title: "Create campaign",
        parentPath: "/campaigns",
        requiredGroups: PermissionGroups.campaigns.write
      },
      {
        element: <UpdateCampaignGroup />,
        path: "/campaigns/campaign-group/:id",
        title: "Campaigns",
        parentPath: "/campaigns"
      },
      {
        element: <DuplicateCampaign />,
        path: "/campaigns/duplicate-campaign/:id",
        title: "Duplicate campaign",
        parentPath: "/campaigns"
      },
      {
        element: <UpdateCampaign />,
        path: "/campaigns/campaign/:id",
        title: "Campaigns",
        parentPath: "/campaigns"
      }
    ]
  }
]
